export type { LettermarkProps } from './Lettermark'
export { Lettermark, LettermarkColor } from './Lettermark'
